module.exports = __webpack_public_path__ + "static/media/dm.da1722f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/dm.png
// module id = 1834
// module chunks = 0